import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import RefreshIcon from '@mui/icons-material/Refresh';
import { JOB_PORTAL_KEYS, NS } from '../../../../i18n/constants/keys';

export const JobListLoading = () => {
  const { t } = useTranslation(NS.jobPortal);

  return (
    <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 8 }}>
      <Stack spacing={2.5} alignItems="center">
        <CircularProgress size={64} thickness={4} />
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h3" color="primary">
            {t(JOB_PORTAL_KEYS.listing.findingOpportunities)}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {t(JOB_PORTAL_KEYS.listing.loadingJobPostings)}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

interface IJobListEmptyProps {
  onClearAllFilters: () => void;
}

export const JobListEmpty = ({ onClearAllFilters }: IJobListEmptyProps) => {
  const { t } = useTranslation(NS.jobPortal);

  return (
    <Paper
      sx={{
        display: 'flex',
        minHeight: 360,
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack spacing={1.5} alignItems="center" sx={{ maxWidth: 480 }}>
        <Avatar sx={{ width: 64, height: 64, bgcolor: 'primary.50', color: 'primary.main' }}>
          <BusinessCenterIcon fontSize="large" />
        </Avatar>
        <Typography variant="h2">{t(JOB_PORTAL_KEYS.listing.noJobsFound)}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t(JOB_PORTAL_KEYS.listing.noJobsMessage)}
        </Typography>
        <Button variant="contained" startIcon={<RefreshIcon fontSize="small" />} onClick={onClearAllFilters}>
          {t(JOB_PORTAL_KEYS.listing.clearAllFilters)}
        </Button>
      </Stack>
    </Paper>
  );
};
